
const LoaderSmall = ({ isLoading, className }) => {
  return (
    <>
      <div className={`loader-small ${className}`}>
        {isLoading && (
          <div class="loader-sm">
            <div class="loader__circle"></div>
            <div class="loader__circle"></div>
            <div class="loader__circle"></div>
            <div class="loader__circle"></div>
          </div>        
        )}
      </div>
    </>
  );
};

export default LoaderSmall;
